import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'

import { Button } from '@bonniernews/dn-design-system-web/components/button/button.tsx'

export interface BlockedContentProps extends SharedProps {
  title: string
  body: string
  link: string
  forcePx?: boolean
  elementAttributes?: { [key: string]: string }
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/blocked-content](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/blocked-content)
 * - Storybook: [BlockedContent](https://designsystem.dn.se/?path=/docs/article-blockedcontent--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/blocked-content/blocked-content.scss'`
 */
export const BlockedContent = ({
  title,
  body,
  link,
  forcePx = false,
  classNames = '',
  attributes = {},
  elementAttributes = {},
}: BlockedContentProps) => {
  const componentClassName = 'ds-blocked-content'
  const classes = formatClassString([componentClassName, forcePx ? 'ds-force-px' : '', classNames])

  return (
    <div className={classes} {...attributes}>
      <div className={`${componentClassName}__inner`}>
        <div className={`${componentClassName}__content`}>
          <h2 className={`${componentClassName}__title`}>{title}</h2>
          <div className={`${componentClassName}__body`}>
            {body}
            <a className={`${componentClassName}__link`} href={link}>
              {link}
            </a>
          </div>
        </div>
        <Button
          text='Hantera kakor och samtycken'
          variant='secondaryFilled'
          size='md'
          fullWidth={true}
          forcePx={forcePx}
          attributes={elementAttributes}
        />
      </div>
    </div>
  )
}

export default BlockedContent
